import Storage from '@/utils/localStorage'

const userKey = 'token'
const refreshKey = 'refresh'
const remember = 'rememberMe'
const userEmail = 'email'

export class StorageService {
  signOut = () => (Storage.getItem(remember) ? Storage.cleanTokens() : Storage.clear())

  updateUserToken = userToken => Storage.setItem(userKey, userToken)

  updateRefreshToken = refreshToken => Storage.setItem(refreshKey, refreshToken)

  getUserToken = () => Storage.getItem(userKey)

  getRefreshToken = () => Storage.getItem(refreshKey)

  setRememberMe = rememberMe => Storage.setItem(remember, rememberMe)

  getRememberMe = () => Storage.getItem(remember)

  setUserEmail = email => Storage.setItem(userEmail, email)

  getUserEmail = () => Storage.getItem(userEmail)

  cleanUp = () => {
    Storage.clear()
  }
}

export default new StorageService()
